import { render, staticRenderFns } from "./AccountMy.vue?vue&type=template&id=3af6775a&"
import script from "./AccountMy.vue?vue&type=script&lang=js&"
export * from "./AccountMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports